module.exports = __webpack_public_path__ + "img/icon-copytext@2x.3e204bce.png";